import "../../utils/tailwind.css";
import { PageProvider } from "./provider";
import Section from "../../components/section";
import { Accordion } from "react-bootstrap";
import Button from "../../components/Buttons";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  return (
    <Section>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="1">
          <Accordion.Header>About Us</Accordion.Header>
          <Accordion.Body>About us details</Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
        <Button type="submit">Save</Button>
      </div>
    </Section>
  );
}
